module.exports = __webpack_public_path__ + "static/img/bfaa3f89-8a64-43a1-9587-3ae9ffd5d064.c12fb4a7.png";